import { render, staticRenderFns } from "./GamePreview.vue?vue&type=template&id=3234774e&scoped=true&"
import script from "./GamePreview.vue?vue&type=script&lang=js&"
export * from "./GamePreview.vue?vue&type=script&lang=js&"
import style0 from "./GamePreview.vue?vue&type=style&index=0&id=3234774e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3234774e",
  null
  
)

export default component.exports